import BookmakerModel from "./Bookmakers/BookmakerModel";
import MatchOddsMarketModel from "./Markets/MatchOddsMarketModel";

export default class MatchOddsModel {
  public bookmaker: BookmakerModel | null = null;
  public type: string | null = null;
  public markets: MatchOddsMarketModel[] = [];
}
